import { AnimationProps, motion } from 'framer-motion'
import { AnimationConfig } from '../utils/variants'
import { PropsWithChildren } from 'react'

type Props = {
  transition?: AnimationProps['transition']
  className?: string
}

const AnimatedCarouselSection = ({
  transition,
  className,
  children
}: PropsWithChildren<Props>) => {
  return (
    <motion.div
      whileInView={AnimationConfig.variants.visible}
      variants={AnimationConfig.variants.initial}
      initial="hidden"
      transition={transition}
      viewport={AnimationConfig.viewport}
      className={className}
    >
      {children}
    </motion.div>
  )
}

export const Section = AnimatedCarouselSection
